import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import CroneList from './crone_list';

class CroneSetting extends Component {
    render() {
        return (
            <div>
                <Switch>

                    <Route path="/settings/cron" component={CroneList}/>
                    {/* <Redirect from="/settings/users" to="/settings/users/list"/> */}
                    <Redirect from="*" to= "/settings/cron"/>
                </Switch>
            </div>
        );
    }
}

export default CroneSetting;
